import React from 'react';
import Navigation from '../components/layout/Navigation';
import Footer from '../components/layout/Footer';
import ServicesContent from '../components/sections/ServicesContent';
import ServicesDetails from './ServicesDetails';

const Services = () => {
  return (
    <div className="min-h-screen site-root">
      <Navigation />
      <ServicesContent />
      <ServicesDetails />
      <Footer />
    </div>
  );
};

export default Services;